// extracted by mini-css-extract-plugin
module.exports = {"gridColumn":"GridColumn_gridColumn__EnzYI"};